import { action, select } from 'satcheljs/lib/legacy';
import markReadStore from '../store/Store';
/**
 * Add each item id in the given list to the suppressed item ids dictionary
 * @param itemIds the itemIds to be added to the suppressed dictionary
 * @param state which contains the markReadStore
 */
export var add = action('AddMarkReadSuppressedItemIds')(select({
    store: function () { return markReadStore; },
})(function add(itemIds, state) {
    itemIds.forEach(function (id) { return (state.store.suppressedItemIdsMap[id] = true); });
}));
/**
 * Clear each item id by removing it from the suppressed item ids dictionary
 * @param itemId the item id to be removed from the suppressed dictionary
 * @param state which contains the markReadStore
 */
export var remove = action('RemoveMarkReadSuppressedItemIds')(select({
    store: function () { return markReadStore; },
})(function remove(itemIds, state) {
    itemIds.forEach(function (id) { return delete state.store.suppressedItemIdsMap[id]; });
}));
/**
 * Clear the suppressed state
 * @param state which contains the markReadStore
 */
export var clear = action('ClearMarkReadSuppressedMap')(select({
    store: function () { return markReadStore; },
})(function clear(state) {
    state.store.suppressedItemIdsMap = {};
}));
/**
 * Whether there is any items to be suppressed
 * @return true if the suppressed map is empty
 */
export function isEmpty() {
    return Object.keys(markReadStore.suppressedItemIdsMap).length == 0;
}
/**
 * Whether specified itemIds is a subset of itemIds in suppressedItemIdsMap
 * @param itemIds the given itemIds
 * @return true if specified itemIds is a subset of itemIds in suppressedItemIdsMap, false otherwise
 */
export function contains(itemIds) {
    for (var i = 0; i < itemIds.length; i++) {
        if (!markReadStore.suppressedItemIdsMap[itemIds[i]]) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=suppressedItemIdsMapOperations.js.map